import React from "react";
import { Snackbar, SnackbarContent, IconButton, makeStyles, Theme } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { green, amber } from "@material-ui/core/colors";
import { ToastVariant } from "../../types";


const useStyle = makeStyles((theme: Theme) => ({
  default: {

  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
}))



export default function Toast(props: {
  message?: string,
  onClose: () => void,
  actions?: React.ReactNode[],
  variant?: ToastVariant
}) {
  const classes = useStyle();
  const { message, onClose, actions, variant } = props;
  const open = !!message;
  const className = classes[variant || 'default'];

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      onClose={onClose}
      autoHideDuration={6000}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
    >
      
      <SnackbarContent
        message={<span id="message-id">{message}</span>}
        className={className}
        action={[
          ...(actions || []),
          <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  )
}